import React, { useEffect, useState } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CNav,
    CNavItem,
    CNavLink,
    CForm,
    CFormInput,
    CFormLabel,
    CButton,
    CFormSwitch,
    CRow,
    CCol,
    CBadge,
    CAlert,
    CInputGroup,
    CInputGroupText,
} from '@coreui/react-pro';
import { useStore } from '../../contexts/StoreContext';
import { DeliveryTypeData } from '../../types/delivery';
import * as DomicilappService from "../../services/DomicilappService";
import { AlertSettingData } from '../../types/alert';
import { useNotification } from '../../contexts/NotificationContext';

export const SettingsPage: React.FC = () => {
    const [activeTab, setActiveTab] = useState('delivery');

    const { storeId, setStoreId, storeDetails } = useStore();
    const [deliveryTypes, setDeliveryTypes] = useState<DeliveryTypeData[]>([]);
    const [originalDeliveryTypes, setOriginalDeliveryTypes] = useState<DeliveryTypeData[]>([]);
    const [alertSettings, setAlertSettings] = useState<AlertSettingData[]>([]);
    const { showModal, showToast } = useNotification();


    useEffect(() => {
        console.log("Entra aqui 25");
        if (storeId) {
            console.log("Entra aqui 27");
            setDeliveryTypes([]);

            DomicilappService.getDeliveryTypesByStore(storeId).then((response) => {
                if (response.status === 200) {
                    setDeliveryTypes(response.data);
                    // Guardamos una copia "base" para poder comparar y saber qué cambió
                    setOriginalDeliveryTypes(response.data);
                }
            });

            // setAlertSettings([]);

            // DomicilappService.getAlertSettingsByStore(storeId).then((response) => {
            //     if (response.status === 200) {
            //         setAlertSettings(response.data);
            //     }
            // });
        }
    }, [storeId])


    useEffect(() => {
        console.log("Entra aqui 57");
        if (storeId) {
            console.log("Entra aqui 59");
            setAlertSettings([]);

            DomicilappService.getAlertSettingsByStore(storeId).then((response) => {
                if (response.status === 200) {
                    setAlertSettings(response.data);
                }
            });
        }
    }, [storeId])

    const [notifications, setNotifications] = useState({
        whatsapp: true,
        sms: false,
    });


    const currencyFormat = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });

    // Actualiza el estado is_active del delivery type que se togglea, por id
    const handleToggleActive = (id: number, checked: boolean) => {
        setDeliveryTypes((prev) =>
            prev.map((dt) =>
                dt.id === id ? { ...dt, is_active: checked ? 1 : 0 } : dt
            )
        );
    };

    // Actualiza el store_subsidy del delivery type que se edita, por id
    const handleSubsidyChange = (id: number, value: number) => {
        setDeliveryTypes((prev) =>
            prev.map((dt) =>
                dt.id === id ? { ...dt, store_subsidy: value } : dt
            )
        );
    };

    // Compara deliveryTypes contra la copia original y devuelve solo los que realmente cambiaron
    const getChangedDeliveryTypes = () => {
        return deliveryTypes.filter((dt) => {
            const original = originalDeliveryTypes.find((o) => o.id === dt.id);
            if (!original) return false;
            return (
                dt.is_active !== original.is_active ||
                dt.store_subsidy !== original.store_subsidy
            );
        });
    };

    // true si hay al menos un delivery type modificado respecto a la data original
    const hasDeliveryChanges = getChangedDeliveryTypes().length > 0;

    // Arma el payload solo con los 3 campos que se deben enviar, y solo de lo que cambió
    const handleSaveDeliverySettings = () => {
        const changedItems = getChangedDeliveryTypes();

        if (changedItems.length === 0) return;

        const payload = changedItems.map((dt) => ({
            id: dt.id,
            store_subsidy: dt.store_subsidy,
            is_active: dt.is_active,
        }));

        console.log('Payload a enviar:', payload);

        DomicilappService.updateDeliveryTypes(storeId, payload).then((response) => {
            console.log(response);
            if (response.status === 200) {
                // Actualizamos la copia base con lo que ya se guardó, así el botón se desactiva de nuevo
                setOriginalDeliveryTypes(deliveryTypes);

                showToast({
                    title: '¡Operación Exitosa!',
                    message: 'Confgiguraciones actualizadas',
                    type: 'success', // 'success' | 'danger' | 'warning' | 'info' | 'brand'
                    delay: 3500,
                });
            }
        });
    };


    // Togglea el switch de una alerta: actualiza el estado local y llama a la API directamente
    const handleAlertToggleActive = (id: number, checked: boolean) => {
        const newActive = checked ? 1 : 0;

        // Update optimista: refleja el cambio en pantalla de inmediato
        setAlertSettings((prev) =>
            prev.map((alert) =>
                alert.id === id ? { ...alert, active: newActive } : alert
            )
        );

        // El payload se arma con el valor nuevo directamente (no depende del estado viejo)
        const payload = { id, active: newActive };
        console.log('Payload a enviar (alert):', payload);

        // TODO: reemplazar por el método real del servicio, por ejemplo:
        DomicilappService.updateAlertSettings(storeId, payload)
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error('No se pudo actualizar la alerta');
                } else {
                    showToast({
                        title: '¡Operación Exitosa!',
                        message: 'Configuraciones actualizadas',
                        type: 'success', // 'success' | 'danger' | 'warning' | 'info' | 'brand'
                        delay: 3500,
                    });
                }
            })
            .catch((error) => {
                console.error(error);
                // Si falla, revierte el switch a su valor anterior
                setAlertSettings((prev) =>
                    prev.map((alert) =>
                        alert.id === id ? { ...alert, active: newActive === 1 ? 0 : 1 } : alert
                    )
                );
            });
    };

    return (
        <CCard className="border border-secondary-subtle shadow-none mb-4 bg-body rounded-3">
            <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3">
                <h6 className="mb-2 fw-bold text-body">Configuración del Comercio</h6>
                <CNav variant="tabs" className="card-header-tabs border-0 mt-2">
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'delivery'}
                            onClick={() => setActiveTab('delivery')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'delivery'
                                ? 'text-body fw-bold border-bottom border-2 border-dark'
                                : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Tipos de Entrega & Subsidios
                        </CNavLink>
                    </CNavItem>
                    <CNavItem>
                        <CNavLink
                            active={activeTab === 'notifications'}
                            onClick={() => setActiveTab('notifications')}
                            className={`px-3 py-2 fw-medium border-0 bg-transparent ${activeTab === 'notifications'
                                ? 'text-body fw-bold border-bottom border-2 border-dark'
                                : 'text-body-secondary'
                                }`}
                            style={{ cursor: 'pointer' }}
                        >
                            Notificaciones
                        </CNavLink>
                    </CNavItem>
                </CNav>
            </CCardHeader>

            <CCardBody className="p-4 bg-body text-body">
                {/* TAB 1: TIPOS DE ENTREGA, TARIFAS Y SUBSIDIOS */}
                {activeTab === 'delivery' && (
                    <CForm>
                        <CAlert color="secondary" className="mb-4 border border-secondary-subtle text-body-secondary bg-body-tertiary small">
                            Configura qué modalidades habilitas en tu tienda y define cuánto aporta tu negocio para asumir las tarifas de DomicilApp o del servicio de entrega.
                        </CAlert>

                        {deliveryTypes && deliveryTypes.map((deliveryType) => {

                            return (
                                <CCard key={deliveryType.id} className="mb-3 border border-secondary-subtle shadow-none bg-body rounded-3">
                                    <CCardBody className="p-3">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <div>
                                                <h6 className="fw-semibold text-body mb-0">{deliveryType.name}</h6>
                                                <small className="text-body-secondary">{deliveryType.description}</small>
                                            </div>
                                            <CFormSwitch
                                                id={`switch-${deliveryType.id}`}
                                                checked={deliveryType.is_active === 1}
                                                onChange={(e) => handleToggleActive(deliveryType.id, e.target.checked)}
                                            />
                                        </div>

                                        {deliveryType.is_active === 1 && (
                                            <CRow className="g-3 align-items-center">
                                                <CCol md={4}>
                                                    <CFormLabel className="small text-body-secondary mb-1">Costo Tarifa DomicilApp</CFormLabel>
                                                    <CInputGroup size="sm">
                                                        <CInputGroupText className="bg-body-tertiary text-body-secondary border-secondary-subtle">$</CInputGroupText>
                                                        <CFormInput className="bg-body-tertiary text-body border-secondary-subtle" value={deliveryType.delivery_price} disabled />
                                                    </CInputGroup>
                                                </CCol>
                                                <CCol md={4}>
                                                    <CFormLabel className="small text-body-secondary mb-1">Aporte de la Tienda (Subsidio)</CFormLabel>
                                                    <CInputGroup size="sm">
                                                        <CInputGroupText className="bg-body-tertiary text-body-secondary border-secondary-subtle">$</CInputGroupText>
                                                        <CFormInput
                                                            type="number"
                                                            className="bg-body text-body border-secondary-subtle"
                                                            max={deliveryType.delivery_price}
                                                            value={deliveryType.store_subsidy}
                                                            onChange={(e) =>
                                                                handleSubsidyChange(deliveryType.id, Number(e.target.value))
                                                            }
                                                        />
                                                    </CInputGroup>
                                                </CCol>
                                                <CCol md={4}>
                                                    <CFormLabel className="small text-body-secondary mb-1">Cobro al Cliente Final</CFormLabel>
                                                    <div className="fw-bold fs-6 text-body mt-1">
                                                        {currencyFormat.format(deliveryType.delivery_price - deliveryType.store_subsidy)}
                                                    </div>
                                                </CCol>
                                            </CRow>
                                        )}
                                    </CCardBody>
                                </CCard>);
                        })
                        }

                        <div className="d-flex justify-content-end">
                            <CButton
                                color="dark"
                                className="px-4 fw-medium text-white"
                                onClick={handleSaveDeliverySettings}
                                disabled={!hasDeliveryChanges}
                            >
                                Guardar Reglas de Subsidio
                            </CButton>
                        </div>
                    </CForm>
                )}

                {/* TAB 2: NOTIFICACIONES A CLIENTES */}
                {activeTab === 'notifications' && (
                    <CForm>
                        <CAlert color="secondary" className="mb-4 border border-secondary-subtle text-body-secondary bg-body-tertiary small">
                            Cada mensaje automático de actualización del pedido enviado a tus clientes se debitará del saldo de tu tienda.
                        </CAlert>
                        {/* {deliveryTypes && deliveryTypes.map((deliveryType) => { */}
                        {alertSettings.map((alert) => {
                            return (
                                <CCard key={alert.id} className="mb-3 border border-secondary-subtle shadow-none bg-body rounded-3">
                                    <CCardBody className="p-3 d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="fw-semibold text-body">{alert.service_type_fullname}</div>
                                            <small className="text-body-secondary">Notificaciones en tiempo real enviada por {alert.service} cuando existe una nueva orden.</small>
                                            <div className="mt-2">
                                                <CBadge color="secondary" className="text-body bg-body-tertiary border border-secondary-subtle fw-normal">
                                                    Costo: {currencyFormat.format(alert.price)} / {alert.service} enviado
                                                </CBadge>
                                            </div>
                                        </div>
                                        <CFormSwitch
                                            id={`switch-alert-${alert.id}`}
                                            checked={alert.active === 1}
                                            onChange={(e) => handleAlertToggleActive(alert.id, e.target.checked)}
                                        />
                                    </CCardBody>
                                </CCard>
                            );
                        })
                        }
                        {/* <div className="d-flex justify-content-end">
                            <CButton color="dark" className="px-4 fw-medium text-white" onClick={handleSaveAlertSettings}>
                                Guardar Canales
                            </CButton>
                        </div> */}
                    </CForm>
                )}
            </CCardBody>
        </CCard>
    );
};

export default SettingsPage;